<mat-drawer-container class="example-container" autosize (backdropClick)="toggleDrawer(true)">
    <mat-drawer #drawer class="desktop-sidenav" mode="over">
        <app-desktop-sidenav (closeNav)="closeDrawer()" [isVisible]="isOpened" [toggle]="toggleClosed"></app-desktop-sidenav>
    </mat-drawer>

    <div class="sidenav-content">
        <div class="desktop-fixed-wrapper">

            <div class="desktop-top" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="nav-aside">
                    <a (click)="toggleDrawer(false)">
                        <img src="{{licenceService.getKey('icon-top-menu')}}" alt="nav-aside">
                    </a>
                </div>
                <div class="top-logo">
                    <a [routerLink]="['/']"><img src="{{licenceService.getKey('logo-desktop')}}" alt="luckera-logo" /></a>
                </div>
                <div class="search-icon-container">
                    <button class="search-btn" (click)="openSearchDialog()" fxLayout="row" fxLayoutAlign="space-between center">
                        <span i18n>Search game...</span>
                        <img style="width: 24px; height: 24px; object-fit: cover;" src="{{licenceService.getKey('search-icon')}}" alt="close-btn" />
                    </button>
                </div>
                <div class="profile-wrapper">
                    <app-user-profile></app-user-profile>
                </div>
                <div class="auth-wrapper">
                    <app-main-auth></app-main-auth>
                </div>
            </div>
        </div>
        <app-desktop-top-menu></app-desktop-top-menu>
        <app-breadcrumbs *ngIf="!isVipPage"></app-breadcrumbs>
        <div #frontContent [ngClass]="[isCalendar?'':'content-wrapper', isVipPage ? 'vip-page' : '', hasExpansionPanel ? 'has-expansion-panel' : '']">
            <router-outlet></router-outlet>
        </div>
        <app-desktop-footer *ngIf="minimizeSiteService.isFooterNotMinimized()|async"></app-desktop-footer>
    </div>

</mat-drawer-container>



<!-- <app-footer *ngIf="minimizeSiteService.isRegularPage()|async"></app-footer> -->